import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { Flyout } from '@els/els-react--flyout';
import { Button, ButtonWithIcon } from '@els/els-react--button';
import RxStructureService from '@Services/RxStructureService';

import './StructureOpenInDatabase.scss';

export default function StructureOpenInDatabase({ metadata, subLinks, onOptionClick = noop }) {
  const openInDatabase = (db) => {
    RxStructureService.openInDatabase(db, get(metadata, 'originalSearchType'));
  };

  return (
    <Flyout
      className="structure-open-in-database"
      flyout={
        <ul role="menu" className="u-els-nowrap">
          {subLinks.map((db) => (
            <li key={db.databaseId}>
              <Button
                type="link"
                linkOptions={['navigation']}
                role="menuitem"
                className={cn('u-els-margin-top-1o4', 'u-els-margin-bottom-1o4', `e2e-${kebabCase(db.label)}`)}
                onClick={() => {
                  onOptionClick(db.label);
                  openInDatabase(db);
                }}>
                {db.label}
              </Button>
            </li>
          ))}
        </ul>
      }
      shouldCloseOnESC
      placement="right">
      <ButtonWithIcon
        sprite="ChevronRight"
        type="link"
        linkIconSize="xs"
        role="menuitem"
        className={cn('e2e-drop-item', 'e2e-open-in-database')}
        onClick={noop}>
        Open in database
      </ButtonWithIcon>
    </Flyout>
  );
}

StructureOpenInDatabase.propTypes = {
  metadata: PropTypes.object,
  subLinks: PropTypes.array,
  onOptionClick: PropTypes.func,
};
